export { default } from './DebianOriginal'



// WEBPACK FOOTER //
// ../src/components/debian/original/index.js